import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {PatientComponent} from './patient.component';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {PatientsRoutesEnum} from './services/navigation/patients-routes.enum';
import {PatientsListComponent} from './patients-list/patients-list.component';
import {PatientDetailsComponent} from './patient-details/patient-details.component';
import {PatientResolver} from './services/resolver/patient.resolver';
import {PatientRouteParamsEnum} from './services/navigation/patient-route-params.enum';

const routes: Routes = [
  {
    path: RoutesEnum.PATIENTS,
    component: PatientComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: PatientsRoutesEnum.LIST,
        component: PatientsListComponent,
      },
      {
        path: `${PatientsRoutesEnum.DETAILS}/:${PatientRouteParamsEnum.PATIENT_ID}`,
        component: PatientDetailsComponent,
        resolve: {patientData: PatientResolver},
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class PatientRoutingModule {
}
